import * as React from 'react';
import parse from 'html-react-parser';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import IDHelpers from '../../../../../../../../core/helpers/IDHelper';
import { Block, Heading, Icon, Text } from '../../../../../../../components';
import { BackButton, InteractiveButton } from '../../../../../components';
import moneyIcon from '../../../../../../../../assets/icons/icon-money.svg';
import lineIcon from '../../../../../../../../assets/icons/icon-line.svg';
import clockIcon from '../../../../../../../../assets/icons/icon-clock-black.svg';
import arrowIcon from '../../../../../../../../assets/icons/icon-arrow-right-purple.svg';
import pinIcon from '../../../../../../../../assets/icons/icon-pin.svg';
import ErrorMessage from './Modals/ErrorMessage';

const ContainerProcedure: React.FC = (props) => {
  const { children } = props;
  return (
    <Block
      data-testid="cmp-containerProcedureB"
      customized
      className="containerProcedureB"
    >
      {children}
    </Block>
  );
};

const Header = (props: any) => {
  const { name, amount, duration } = props;
  return (
    <Block
      data-testid="cmp-certificateHeader"
      customized
      justifyContent="flex-start"
      margin="0px 0px 8px 0px"
    >
      {name && (
        <Heading
          text={name}
          level={2}
          color="var(--text-text02)"
          size={18}
          lineHeight={28}
          fontWeight="900"
          className=""
          align="flex-start"
        />
      )}
      {amount && duration && (
        <Block
          customized
          flexDirection="row"
          alignItems="center"
          margin="8px 0px 12px 0px"
        >
          <Icon
            customized
            maxWidth="16.9px"
            height="15px"
            margin="0px 4.67px 0px 0px"
          >
            <img src={moneyIcon} alt="other" />
          </Icon>
          <Text
            color="#161D1F"
            fontSize="14px"
            lineHeight="20px"
            fontWeight="400"
          >
            Costo{' '}
            <Text as="strong" fontWeight="900">
              S/. {amount}.00
            </Text>
          </Text>
          <Icon
            customized
            maxWidth="1px"
            height="13px"
            margin="0px 0px 0px 16px"
          >
            <img src={lineIcon} alt="other" />
          </Icon>
          <Icon customized maxWidth="13.33px" margin="0px 5.33px 0px 17.33px">
            <img src={clockIcon} alt="other" />
          </Icon>
          <Text
            color="#161D1F"
            fontSize="12px"
            lineHeight="16px"
            fontWeight="400"
          >
            {duration}
          </Text>
        </Block>
      )}
    </Block>
  );
};

const ButtonBack = ({ goto, onClick }: any) => {
  const history = useHistory();
  return (
    <Block
      data-testid="cmp-certificateButtonBack"
      customized
      justifyContent="flex-start"
      margin="0px 0px 16px"
    >
      <BackButton
        onClick={() => {
          if (goto) history.push(goto);
          else onClick();
        }}
      />
    </Block>
  );
};

const WhiteContainer = ({ children }: any) => (
  <Block
    data-testid="cmp-certificateWhiteContainer"
    customized
    maxWidth={isMobile ? '100%' : '744px'}
    backgroundColor="#fff"
    padding="24px"
    borderRadius="8px"
    margin="12px 0px 0px 0px"
    justifyContent="flex-start"
  >
    {children}
  </Block>
);

const Pin1 = ({ message }: any) => {
  const messageSafe = parse(message || '');
  return (
    <Block
      data-testid="cmp-certificatePin1"
      customized
      flexDirection="row"
      alignItems={isMobile ? 'flex-start' : 'center'}
      maxWidth={isMobile ? '100%' : '744px'}
      backgroundColor="#fff"
      padding="0px"
      borderRadius="8px"
    >
      <Icon
        customized
        alignItems="center"
        justifyContent="center"
        backgroundColor="#E2DFFD"
        maxWidth="24px"
        height="24px"
        margin="0px 8px 0px 0px"
        borderRadius="100%"
      >
        <img src={pinIcon} alt="other" />
      </Icon>
      <Text color="#1A055D" fontSize="14px" lineHeight="20px" fontWeight="400">
        {messageSafe}
      </Text>
    </Block>
  );
};

const StepsToFollow = ({ steps, modelFile }: any) => (
  <WhiteContainer>
    <>
      <Heading
        text="Pasos a seguir:"
        level={3}
        color="var(--text-text02)"
        size={14}
        lineHeight={20}
        fontWeight="700"
        className=""
        align="flex-start"
        width="100%"
      />
      <Block customized margin="12px 0px 0px 16px" style={{ width: 'auto' }}>
        <ol style={{ listStyle: 'decimal' }}>
          {steps?.map((r: string) => (
            <li key={IDHelpers.generateID()}>{r}</li>
          ))}
        </ol>
      </Block>
      <InteractiveButton
        bkgColorEnabled="none"
        bkgColorHover="#E2DFFD"
        bkgColorFocus="#C6C0FC"
        bkgColorPressed="#C6C0FC"
        customized
        as="a"
        target="_blank"
        href={`../../assets/documents/${modelFile}`}
        border="1px solid #5B36F2"
        flexDirection="row"
        alignItems="center"
        justifyContent={isMobile ? 'center' : 'flex-start'}
        backgroundColor="#FFF"
        padding="10px 16px"
        borderRadius="4px"
        margin="12px 0px 0px 0px"
        width={isMobile ? '100%' : '126px'}
        download={modelFile}
      >
        <Text
          color="#5B36F2"
          fontSize="14px"
          lineHeight="20px"
          fontWeight="700"
        >
          Ver modelo
        </Text>
        <Icon customized maxWidth="12px" margin="0px 0px 0px 7px">
          <img src={arrowIcon} alt="chevron" />
        </Icon>
      </InteractiveButton>
    </>
  </WhiteContainer>
);

const ActionableButton = ({ text, onClick, enabled, marginTop }: any) => (
  <InteractiveButton
    data-testid="cmp-certificateActionableButton"
    bkgColorEnabled={enabled ? '#5B36F2' : '#D5E5F0'}
    bkgColorHover={enabled ? '#745EF6' : '#D5E5F0'}
    bkgColorFocus={enabled ? '#4318CD' : '#D5E5F0'}
    bkgColorPressed={enabled ? '#4318CD' : '#D5E5F0'}
    customized
    cursor={enabled ? 'pointer' : 'default'}
    backgroundColor={enabled ? '#5B36F2' : '#D5E5F0'}
    padding="10px 16px"
    borderRadius="4px"
    margin={`${marginTop || 40}px 0px 0px 0px`}
    width={isMobile ? '100%' : 'auto'}
    onClick={enabled ? onClick : {}}
    justifyContent={isMobile ? 'center' : 'flex-start'}
    alignContent={isMobile ? 'center' : 'flex-start'}
    alignItems={isMobile ? 'center' : 'flex-start'}
  >
    <Text
      color={enabled ? '#FFFFFF' : '#8090BB'}
      fontSize="14px"
      lineHeight="20px"
      fontWeight="700"
      textAlign={isMobile ? 'center' : 'left'}
    >
      {text}
    </Text>
  </InteractiveButton>
);

export {
  Header,
  ButtonBack,
  ContainerProcedure,
  WhiteContainer,
  Pin1,
  StepsToFollow,
  ActionableButton,
  ErrorMessage
};
